import React from "react";
import { toast } from "react-toastify";
import { debounce } from "lodash";

import API from "../../services/api.jsx";
import Helpers from "../../services/helpers.jsx";
import Loader from "../layout/loader.jsx";
import Head from "../layout/head.jsx";
import Content from "../layout/content.jsx";
import Table from "../layout/table.jsx";

class UsersList extends React.PureComponent {
  constructor(props) {
    super(props);

    const tabsLinks = [];
    if (Helpers.checkPermissions("users:list")) {
      tabsLinks.push({ title: "Users", path: "/users/list" });
    }
    if (Helpers.checkPermissions("roles:list")) {
      tabsLinks.push({ title: "Roles", path: "/users/roles" });
    }

    const columns = [
      {
        label: "Name",
        key: "name",
        view: (_, entity) => {
          if (entity) {
            return entity?.name;
          }
          return "-";
        },
      },
      {
        label: "Email",
        key: "email",
      },
      {
        label: "Role",
        key: "role.name",
        canSort: true,
        view: (_, entity) => {
          if (entity) {
            return entity.role?.name;
          }
          return "-";
        },
        onSortClick: (column) => this.onSort(column.key),
      },
      {
        label: "Assigned affiliate(s)",
        key: "affiliates",
        view: (field) => {
          if (Array.isArray(field)) {
            if (field.length === 0) {
              return "All";
            } else {
              return field?.map((affiliate) => affiliate.name)?.join(", ");
            }
          } else {
            return "-";
          }
        },
      },
    ];
    if (Helpers.checkPermissions("users:delete")) {
      columns.push({
        action: "delete",
        onClick: (id, key) => {
          var r = window.confirm("Are you sure you want to delete this user?");
          if (r === false) return;

          this.setState({ loading: true });
          API.delete("users", id)
            .then(() => {
              toast.success("User was successfully deleted");
              this.loadEntities();
            })
            .catch(() => {
              // toast.error("An unexpected error has occurred");
              this.setState({ loading: false });
            });
        },
      });
    }

    const actions = [];
    if (Helpers.checkPermissions("users:edit")) {
      actions.push({
        classList: "blue add",
        label: "New user",
        onClick: () => this.props.history.push("/users/new"),
      });
    }

    this.state = {
      clients: [],
      loading: true,
      search: "",
      filters: {},
      sort: ["createdAt", "DESC"],
      tabs: {
        links: tabsLinks,
      },
      users: {
        columns,
        entities: [],
        filters: [
          {
            label: "Search",
            onChange: debounce((value) => {
              if (value !== this.state.filters.name) {
                const newFilter = Helpers.cleanObject({
                  ...this.state.filters,
                  name: value,
                });
                this.setState({ filters: newFilter }, () => {
                  this.loadEntities();
                });
              }
            }, 500),
          },
          {
            label: "Affiliate",
            type: "select",
            value: null,
            placeholder: "Affiliate",
            isClearable: true,
            onChange: (value) => {
              if (value !== this.state.filters?.affiliates) {
                const newFilters = [...this.state.users.filters];
                newFilters[1].value = value;

                let newFilter = {
                  ...this.state.filters,
                  affiliate: value?.id,
                };
                newFilter = Helpers.cleanObject(newFilter);
                this.setState(
                  {
                    filters: newFilter,
                    users: {
                      ...this.state.users,
                      filters: newFilters,
                    },
                  },
                  () => {
                    this.loadEntities();
                  }
                );
              }
            },
          },
        ],
        actions,
        selectedItems: [],
        multiSelect: false,
        onRowClick: (entity) => {
          if (
            Helpers.checkPermissions(
              ["users:details", "users:edit"],
              true
            )
          ) {
            this.props.history.push(`/users/${entity.id}/edit`);
          }
        },
      },
    };
  }

  componentDidMount() {
    this.loadEntities();
  }

  onSort(key) {
    const newSort =
      this.state?.sort?.[0] === key
        ? this.state?.sort?.[1] === "ASC"
          ? [key, "DESC"]
          : [key, "ASC"]
        : [key, "ASC"];
    this.setState(
      {
        sort: newSort,
      },
      () => {
        this.loadEntities();
      }
    );
  }

  loadEntities() {
    API.getUsers(this.state.filters, this.state.sort)
      .then((entities) => {
        const filters = [];
        if (entities?.filters?.availableFilters) {
          Helpers.handleFilters(this, filters, entities);
        }

        this.setState({
          ...this.state,
          users: {
            ...this.state.users,
            filters,
            entities: entities?.data || [],
          },
          loading: false,
        });
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message || "An unexpected error has occurred"
        );
        this.setState({ loading: false });
      });
  }

  render() {
    if (this.state.loading) return <Loader />;
    else
      return (
        <>
          <Head title={"Users"} tabs={this.state.tabs} />
          <Content>
            <Table
              settings={this.state.users}
              loadEntities={this.loadEntities}
              sort={this.state.sort}
            />
          </Content>
        </>
      );
  }
}

export default UsersList;
